import { createContext } from "react";

const facilitiesContext = createContext();

export default facilitiesContext;